module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gunda-power-system","short_name":"starter","start_url":"/","background_color":"#3498db","theme_color":"#3498db","display":"minimal-ui","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"eb561c9af8d87ccc4b05f26209814449"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
